import { useState } from 'react'
import { FileUp, FileDown } from 'lucide-react'
import { T } from '../../styles/theme'
import ExportModal from '../../components/ExportModal'
import ImportModal from '../../components/ImportModal'

export default function Pacientes({ patients, loading, onSelect, onSignOut, onNuevoUsuario, profesionalId, refetch }) {
  const [showExport, setShowExport] = useState(false)
  const [showImport, setShowImport] = useState(false)
  const counts = {
    green: patients.filter(p => p.status === 'green').length,
    yellow: patients.filter(p => p.status === 'yellow').length,
    red: patients.filter(p => p.status === 'red').length,
  }

  return (
    <div>
      <div style={{ padding: '52px 20px 12px', position: 'sticky', top: 0, zIndex: 10, background: T.bg }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <div style={{ fontSize: 26, fontWeight: 700, letterSpacing: -0.5 }}>Mis pacientes</div>
            <div style={{ fontSize: 13, color: T.muted, marginTop: 2 }}>{patients.length} activos</div>
          </div>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <button onClick={onSignOut} style={{ background: 'none', border: 'none', color: T.muted, fontSize: 12, cursor: 'pointer' }}>Salir</button>
            <button onClick={onNuevoUsuario} style={{ background: T.accentSoft, border: `1px solid ${T.accent}`, color: T.accent, borderRadius: 10, padding: '7px 12px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>+ Nuevo</button>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 10 }}>
          <button onClick={() => setShowExport(true)} disabled={patients.length === 0} title="Exportar pacientes" style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: 32, height: 32, borderRadius: 10, background: 'none', border: `1px solid ${T.cardB}`,
            color: T.muted, cursor: patients.length === 0 ? 'not-allowed' : 'pointer', opacity: patients.length === 0 ? 0.5 : 1,
          }}>
            <FileUp size={16} />
          </button>
          <button onClick={() => setShowImport(true)} disabled={patients.length === 0} title="Importar copia de seguridad" style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: 32, height: 32, borderRadius: 10, background: 'none', border: `1px solid ${T.cardB}`,
            color: T.muted, cursor: patients.length === 0 ? 'not-allowed' : 'pointer', opacity: patients.length === 0 ? 0.5 : 1,
          }}>
            <FileDown size={16} />
          </button>
        </div>
      </div>

      <ExportModal patients={patients} open={showExport} onClose={() => setShowExport(false)} />
      <ImportModal
        mode="professional"
        myPatients={patients}
        profesionalId={profesionalId}
        open={showImport}
        onClose={() => setShowImport(false)}
        onImported={refetch}
      />

      {/* Resumen */}
      <div style={{ display: 'flex', gap: 8, margin: '0 16px 16px' }}>
        {[['🟢', 'Bien', counts.green], ['🟡', 'Revisar', counts.yellow], ['🔴', 'Alerta', counts.red]].map(([e, l, n]) => (
          <div key={l} style={{ flex: 1, background: T.card, border: `1px solid ${T.cardB}`, borderRadius: 12, padding: '10px 8px', textAlign: 'center' }}>
            <div style={{ fontSize: 16, fontWeight: 700 }}>{n}</div>
            <div style={{ fontSize: 10, color: T.muted, marginTop: 2, textTransform: 'uppercase', letterSpacing: 0.5 }}>{e} {l}</div>
          </div>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', color: T.muted, padding: 40 }}>Cargando pacientes...</div>
      ) : patients.length === 0 ? (
        <div style={{ textAlign: 'center', color: T.muted, padding: 40 }}>
          No tienes pacientes asignados aún.
        </div>
      ) : patients.map(p => {
        const col = p.status === 'green' ? T.accent : p.status === 'yellow' ? T.warn : T.danger
        const initials = p.nombre?.split(' ').map(n => n[0]).join('').slice(0, 2) ?? '?'
        return (
          <div key={p.id} onClick={() => onSelect(p.id)} style={{
            background: T.card, border: `1px solid ${T.cardB}`, borderRadius: 14,
            padding: '14px 16px', margin: '0 16px 8px',
            display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer'
          }}>
            <div style={{
              width: 42, height: 42, borderRadius: 12, flexShrink: 0,
              background: col + '22', color: col,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 15, fontWeight: 700
            }}>{initials}</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 600 }}>{p.nombre}</div>
              <div style={{ fontSize: 12, color: T.muted, marginTop: 2 }}>
                {p.goals?.tipo ?? 'Sin objetivo'} · Peso: {p.peso ? p.peso + ' kg' : 'Sin datos'}
              </div>
              <div style={{ marginTop: 6 }}>
                <div style={{ fontSize: 11, color: T.muted, marginBottom: 3 }}>
                  {p.alerts.length > 0 ? `${p.alerts.length} alerta(s) activa(s)` : 'Sin alertas'}
                </div>
                <div style={{ height: 4, background: T.cardB, borderRadius: 2, overflow: 'hidden' }}>
                  <div style={{ height: '100%', borderRadius: 2, width: p.alerts.length === 0 ? '100%' : '30%', background: col }} />
                </div>
              </div>
            </div>
            <div style={{ width: 8, height: 8, borderRadius: 4, background: col, flexShrink: 0 }} />
          </div>
        )
      })}
    </div>
  )
}